import React from 'react';
import { acceptVendorInvite, getVendorInvite } from '@api/vendorInvite';
import AcceptInvitePage from '@components/containers/invite/AcceptInvitePage';

/**
 * The manufacturer's way in, from the emailed link.
 *
 * Lands on /vendor/home rather than / - RoleAwareLayout would bounce a VENDOR session there
 * anyway, but arriving directly saves the new user their first redirect.
 */
const AcceptVendorInvite: React.FC = () => (
    <AcceptInvitePage
        description="You've been invited to manage your site's production orders on Reparo."
        fetchInvite={getVendorInvite}
        accept={acceptVendorInvite}
        landing="/vendor/home"
    />
);

export default AcceptVendorInvite;
